import React from "react";
import { Tooltip } from 'antd';

import "./progressBarChart.scss";

// Progress Bar Chart Props :
// config = [ { title : String, count : Number, color : string } ]
// isLabelRequired : Boolean ( if true label along with color code for steps is shown)

const ProgressBarChart = (props: any) => {

  const totalCount = props?.config.reduce((accumulator: any, currentValue: any) => accumulator + currentValue?.count, 0);

  const filterCount = () =>{
    return props?.config?.filter((step:any)=>step?.count !== undefined && step?.count !== null && step?.count !== "" && step?.count !== 0).length -1;
  }
  
  return (
    <div style={{width: "100%"}}>
      <div className="statusBar">
        {props?.config?.filter((step:any)=>step?.count !== undefined && step?.count !== null && step?.count !== "" && step?.count !== 0)?.map((steps: any, index: any) => {
          return (
            <Tooltip placement="top" title={steps.toolTipVal ? steps.toolTipVal : steps.count}>
              <div
                key={index}
                className="statusBar__steps"
                style={{
                  width: `${(steps?.count / totalCount) * 100}%`,
                  background: steps?.color,
                  borderTopLeftRadius: `${index === 0 ? "4px" : "0"}`,
                  borderBottomLeftRadius: `${index === 0 ? "4px" : "0"}`,
                  borderTopRightRadius: `${index === filterCount() ? "4px" : "0"}`,
                  borderBottomRightRadius: `${index === filterCount() ? "4px" : "0"}`,
                }}
              />
            </Tooltip>
          );
        })}
      </div>
      {
        props?.isLabelRequired ? (
          <div className="statusBar__item-container">
          {props?.config?.filter((step:any)=>step?.count !== undefined && step?.count !== null && step?.count !== "" && step?.count !== 0)?.map((item: any, index: any) => {
            return (
              <div className="statusBar__item-container__item" key={index}>
                <div className="statusBar__item-container__item__color" style={{ background: item.color }} />
                <div className="statusBar__item-container__item__label">{item.title}</div>
              </div>
            );
          })}
        </div>
        ) : null
      }
    </div>
  );
};

export default ProgressBarChart;
